import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, DestroyRef, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { switchMap } from 'rxjs';
import { News } from '@tanzspass/shared';
import { School } from '@tanzspass/shared';
import { NewsService } from '../../services/news.service';
import { SchoolService } from '../../services/school.service';
import { PictureComponent } from '../../shared/picture/picture.component';

@Component({
  selector: 'ts-news-header',
  templateUrl: './news-header.component.html',
  styleUrls: ['./news-header.component.css'],
  host: { ngSkipHydration: 'true' },
  imports: [NgIf, PictureComponent, RouterLink],
})
export class NewsHeaderComponent implements OnInit, OnDestroy {
  public school: School = new School();
  public news: News[] = [];
  public currentNews: News = new News();
  private newsCounter = 0;
  private rotation?: ReturnType<typeof setInterval>;

  constructor(
    private schoolSrv: SchoolService,
    private newsSrv: NewsService,
    private destroyRef: DestroyRef,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  private nextNews() {
    this.currentNews = this.news[this.newsCounter];
    this.newsCounter = this.newsCounter < this.news.length - 1 ? this.newsCounter + 1 : 0;
  }

  ngOnInit() {
    this.schoolSrv
      .current()
      .pipe(
        switchMap((school) => {
          this.school = school;
          return this.newsSrv.bySchoolId(school.id);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((news) => {
        this.news = news;
        this.nextNews();
        // Rotate headlines; start once and clear on destroy (was a leaked interval).
        if (isPlatformBrowser(this.platformId) && !this.rotation) {
          this.rotation = setInterval(() => this.nextNews(), 10000);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.rotation) {
      clearInterval(this.rotation);
    }
  }
}
